<template>
  <div>
    <div class="card">
      <div class="card-content">
        <div class="buttons-tab c44">
          <a :class="type === 'consume' ? 'active' : ''" class="tab-link  button" @click="handleChangeType('consume')">消费订单</a>
          <a :class="type === 'recharge' ? 'active' : ''" class="tab-link button" @click="handleChangeType('recharge')">充值订单</a>
        </div>

        <div class="item-block">
          <ul v-if="data">
            <li
              v-for="item in listData"
              :key="item.order_number"
              @click="handelQueryDetail(item.order_number)"
            >
              <div class="item-block-cet">
                <div class="img">
                  <img :src="item.icon" alt>
                </div>
                <div class="item-block-text">
                  <p>{{ item.pay_at }}</p>
                  <p class="c44">{{ item.pay_resource }}</p>
                </div>
              </div>
              <div class="item-block-tec">
                <span>{{ item.pay_status }}</span>
                <span :class="item.pay_status === '部分退款' ? 'cA39' :''">{{ item.deal_amount }}</span>
              </div>
            </li>
          </ul>
          <ul v-if="!data">
            <li>
              <span :style="{'font-size':'13px',color:'#444'}">暂无交易记录</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    listData: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {

    }
  },
  computed: {
    data() {
      let b = false
      if (this.listData && this.listData.length > 0) {
        b = true
      } else {
        b = false
      }
      return b
    }
  },
  methods: {
    handelQueryDetail(v) {
      this.$router.push({ name: 'order', query: { num: v }})
    },
    handleChangeType(v) {
      this.$emit('handleUpdate', v)
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../../../assets/styles/index.less";
.card {
  border-radius: 5px;
}
</style>
